const size = {
  maxWidth: 475
};

export default size;
